import React, { useState, useContext, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlinePlusSm, HiOutlineMinusSm } from "react-icons/hi";
import ParameterContext from "../context/parameter/parameterContext";
import VTradingContext from "../context/vTrading/VTradingContext";
import CryptoContext from "../context/crypto/cryptoContext";
import { withRouter } from "react-router";
import { BiWallet } from "react-icons/bi";
import { formatPrice } from "../helpers/format";
import { GiTwoCoins } from "react-icons/gi";
import { toast } from "react-toastify";
import Message from "./Message";
import { FcInfo } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
const Modal = ({ location }) => {
  const {
    toggleVtradingModal,
    activePortfolio,
    setOrderType,
    placeOrderType,
    vtButton,
    setActivePortfolioPage,
    setVtButton,
  } = useContext(ParameterContext);

  const {
    setSellType,
    placeOrder,
    activeCrypto,
    orderType,
    activePrice,
    modifyOrder,
    placeStoplimitOrder,
    PCSTAmount,
    placeMarketBuyOrder,
    placeMarketSellOrder,
    portId,
  } = useContext(VTradingContext);
  const { exchangeRate } = useContext(CryptoContext);
  const [message, setMessage] = useState({ status: 0, desc: "" });

  //

  const [order, setOrder] = useState({
    amount:
      orderType === "sell"
        ? activePrice?.maxAmount
          ? activePrice?.maxAmount
          : 1
        : 1,
    CSTAmount: activePrice.price * 1,
    buyPrice: activePrice.price,
    sellPrice: activePrice.price,
  });
  useEffect(() => {
    setOrder({
      amount: 1,
      CSTAmount: activePrice.price,
      buyPrice: activePrice.price,
      sellPrice: activePrice.price,
    });
    //eslint-disable-next-line
  }, [placeOrderType]);

  useEffect(() => {
    if (
      order.CSTAmount === "" ||
      order.amount === "" ||
      !isFinite(order.CSTAmount) ||
      !isFinite(order.amount) ||
      order.buyPrice === "" ||
      !isFinite(order.buyPrice) === "" ||
      !isFinite(order.sellPrice) ||
      order.sellPrice === ""
    ) {
      setMessage({
        status: 1,
        desc: "Fields cannot be empty",
      });
    } else if (
      vtButton !== "openOrder" &&
      PCSTAmount === 0 &&
      orderType === "buy"
    ) {
      setMessage({
        status: 1,
        desc: "Your wallet is Empty",
      });
    } else if (orderType === "sell" && order.amount > activePrice.maxAmount) {
      setMessage({
        status: 1,
        desc: "Amount of Coins can't exceed Maximum Amount you have",
      });
    } else if (
      vtButton !== "openOrder" &&
      orderType === "buy" &&
      order.CSTAmount > PCSTAmount / exchangeRate
    ) {
      setMessage({
        status: 1,
        desc: "Total Amount can't exceed Maximum Amount you have",
      });
    } else {
      setMessage({ status: 0, desc: "" });
    }
    //eslint-disable-next-line
  }, [orderType, placeOrderType, order, PCSTAmount]);
  useEffect(() => {
    if (location?.pathname?.split("/")?.includes("screen")) {
      setSellType("buy");

      setVtButton("position");
    } else {
      if (orderType === "sell") {
        setOrder({
          ...order,
          amount: activePrice.maxAmount,
        });
      }
    }
    //eslint-disable-next-line
  }, []);
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (e.target.value !== "-") {
      if (
        isFinite(value) &&
        !isNaN(value) &&
        typeof value !== "undefined" &&
        value !== null &&
        value !== ""
      ) {
        if (value === 0) {
          setOrder({ ...order, [name]: 0 });
        } else {
          if (name === "sellPrice") {
            setOrder({ ...order, sellPrice: value });
          }
          if (orderType === "buy") {
            if (name === "amount") {
              if (order.buyPrice === "") {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: value * order.buyPrice,
                });
              }
            } else if (name === "CSTAmount") {
              if (order.buyPrice === "") {
                setOrder({
                  ...order,
                  [name]: value,
                  amount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,
                  amount:
                    value /
                    (placeOrderType === "market"
                      ? activePrice.price
                      : order.buyPrice),
                });
              }
            } else if (name === "buyPrice") {
              if (order.CSTAmount === "") {
                setOrder({
                  ...order,
                  [name]: value,

                  amount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,

                  amount: order.CSTAmount / value,
                });
              }
            }
          } else if (orderType === "sell") {
            if (name === "amount") {
              if (order.buyPrice === "") {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: value * order.buyPrice,
                });
              }
            } else if (name === "CSTAmount") {
              if (order.buyPrice === "") {
                setOrder({
                  ...order,
                  [name]: value,
                  amount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,
                  amount:
                    value /
                    (placeOrderType === "limit"
                      ? order.buyPrice
                      : activePrice.price),
                });
              }
            } else if (name === "buyPrice") {
              if (order.amount === "") {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: "",
                });
              } else {
                setOrder({
                  ...order,
                  [name]: value,
                  CSTAmount: value * order.amount,
                });
              }
            }
          }
        }
      } else {
        if (name === "buyPrice" && value === "") {
          setOrder({ ...order, CSTAmount: "", amount: "", buyPrice: "" });
        } else if (
          (name === "amount" || name === "CSTAmount") &&
          value === ""
        ) {
          setOrder({ ...order, CSTAmount: "", amount: "" });
        } else setOrder({ ...order, ...order, [name]: "" });
      }
    }
  };
  const handleWalletAmount = (cstAmount) => {
    setOrder({
      ...order,
      CSTAmount: cstAmount,
      amount: cstAmount / order.buyPrice,
    });
  };
  const handleCoinAmount = (amount) => {
    setOrder({
      ...order,
      amount,
      CSTAmount: amount * order.buyPrice,
    });
  };
  const handleIncrement = (e) => {
    const { id } = e.target;
    if (id === "sellPrice") {
      setOrder({ ...order, sellPrice: order.sellPrice + 1 });
    }
    if (orderType === "buy") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount + 1,
          amount: (order.CSTAmount + 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount + 1,
          CSTAmount: (order.amount + 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice + 1,
          amount: order.CSTAmount / (order.buyPrice + 1),
        });
      }
    } else if (orderType === "sell") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount + 1,
          amount: (order.CSTAmount + 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount + 1,
          CSTAmount: (order.amount + 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice + 1,
          CSTAmount: (order.buyPrice + 1) * order.amount,
        });
      }
    }
  };
  const handleDecrement = (e) => {
    const { id } = e.target;
    if (id === "sellPrice") {
      setOrder({ ...order, sellPrice: order.sellPrice - 1 });
    }
    if (orderType === "buy") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount - 1,
          amount: (order.CSTAmount - 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount - 1,
          CSTAmount: (order.amount - 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice - 1,
          amount: order.CSTAmount / (order.buyPrice - 1),
        });
      }
    } else if (orderType === "sell") {
      if (id === "CSTAmount") {
        setOrder({
          ...order,
          CSTAmount: order.CSTAmount - 1,
          amount: (order.CSTAmount - 1) / order.buyPrice,
        });
      } else if (id === "amount") {
        setOrder({
          ...order,
          amount: order.amount - 1,
          CSTAmount: (order.amount - 1) * order.buyPrice,
        });
      } else if (id === "buyPrice") {
        setOrder({
          ...order,
          buyPrice: order.buyPrice - 1,
          CSTAmount: (order.buyPrice - 1) * order.amount,
        });
      }
    }
  };
  const handleBuyClick = (amount) => {
    //null check for sell Price
    if (
      order.amount === "" ||
      order.CSTAmount === "" ||
      order.buyPrice === ""
    ) {
      toast.error("Fields cannot be empty", { autoClose: 6000 });
    } else {
      activePrice?.orderId
        ? modifyOrder({
            orderid: activePrice.orderId,
            amount: order.amount,
            price: order.buyPrice * exchangeRate,
          })
        : placeOrderType === "stoplimit"
        ? placeStoplimitOrder({
            sellprice: order.sellPrice * exchangeRate,
            buyprice: order.buyPrice * exchangeRate,
            amount: order.amount,
            portId: portId,
            symbol: activeCrypto.symbol,
          })
        : placeOrderType === "market" && orderType === "buy"
        ? placeMarketBuyOrder({
            symbol: activeCrypto.symbol,
            portId: portId,
            type: orderType,
            total: order.CSTAmount * exchangeRate,
          })
        : placeOrderType === "market" && orderType === "sell"
        ? placeMarketSellOrder({
            symbol: activeCrypto.symbol,
            portId: portId,
            type: orderType,
            amount: order.amount,
          })
        : placeOrder({
            amount: order.amount,
            symbol: activeCrypto.symbol,
            price: order.buyPrice * exchangeRate,
            portId: portId,
            type: orderType,
          });

      toggleVtradingModal();
    }
  };
  return (
    <div className="Register">
      <div className="Modal__container" style={{ overflowY: "auto" }}>
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={() => {
              toggleVtradingModal();
              setSellType("buy");
            }}
          />
        </div>
        <div className="Register__content">
          <center>
            <div className="TradathonRoom__formContainer__toggleSwitch">
              <div
                className="TradathonRoom__formContainer_toggleSwitch__items"
                style={{
                  color: orderType === "buy" ? "#fff" : "#000",
                  background: orderType === "buy" ? "#8d0792" : "#eff2f5",
                }}
                onClick={() => {
                  setSellType("buy");
                }}
              >
                <h4>BUY</h4>
              </div>

              <div
                className="TradathonRoom__formContainer_toggleSwitch__items"
                style={{
                  color: orderType === "buy" ? "#000" : "#fff",
                  background: orderType === "buy" ? "#eff2f5" : " #E93848",
                }}
                onClick={() => {
                  setSellType("sell");
                }}
              >
                <h4>SELL</h4>
              </div>
            </div>
          </center>

          <div className="Tradathon__investment__page__container">
            {[...Array(3).keys()].map((i, index) => (
              <div
                key={i}
                className={activePortfolio === index + 1 ? "active__div" : ""}
                onClick={() => setActivePortfolioPage(index + 1)}
              >
                {index + 1}
              </div>
            ))}
          </div>

          <div className="Modal__header">
            <p
              onClick={() => setOrderType("limit")}
              style={{
                color: placeOrderType === "limit" ? "#8d0792" : "#000",
              }}
            >
              Limit
            </p>
            <p
              onClick={() => setOrderType("market")}
              style={{
                color: placeOrderType === "market" ? "#8d0792" : "#000",
              }}
            >
              Market
            </p>
            {orderType === "buy" &&
              location.pathname !== "/vtrading" &&
              vtButton !== "openOrder" && (
                <p
                  onClick={() => setOrderType("stoplimit")}
                  style={{
                    color: placeOrderType === "stoplimit" ? "#8d0792" : "#000",
                  }}
                >
                  Stop Limit
                </p>
              )}
          </div>

          <div>
            <>
              {placeOrderType !== "stoplimit" && (
                <>
                  <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                    AT Price
                  </h4>
                  <div className="ModalContent__set">
                    <input
                      type="number"
                      min="0"
                      name="buyPrice"
                      value={order.buyPrice}
                      readOnly={placeOrderType === "market" ? true : false}
                      onChange={handleChange}
                    />
                    {placeOrderType !== "market" && (
                      <div className="ModalContent__icons">
                        <button
                          style={{
                            background: "#e8ecf0",
                            cursor: "pointer",
                            visibility: order.price <= 1 ? "hidden" : "visible",
                          }}
                          onClick={handleDecrement}
                        >
                          <HiOutlineMinusSm size={18} id="buyPrice" />
                        </button>
                        <button
                          style={{
                            background:
                              orderType === "buy"
                                ? "rgba(69, 170, 67, 1)"
                                : "#E93848",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={handleIncrement}
                        >
                          <HiOutlinePlusSm size={18} id="buyPrice" />
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}
              <>
                {placeOrderType === "stoplimit" && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "50px",
                      cursor: "pointer",
                      borderBottom: "2px solid #BABABA",
                    }}
                  >
                    <div>
                      <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                        AT Price
                      </h4>
                      <div className="ModalContent__set" style={{ border: 0 }}>
                        <input
                          type="number"
                          min="0"
                          name="buyPrice"
                          value={order.buyPrice}
                          onChange={handleChange}
                          style={{ width: "50%" }}
                        />

                        <div className="ModalContent__icons">
                          <button
                            style={{
                              background: "#e8ecf0",
                              cursor: "pointer",
                              visibility:
                                order.price <= 1 ? "hidden" : "visible",
                            }}
                            onClick={handleDecrement}
                          >
                            <HiOutlineMinusSm size={18} id="buyPrice" />
                          </button>
                          <button
                            style={{
                              background:
                                orderType === "buy"
                                  ? "rgba(69, 170, 67, 1)"
                                  : "#E93848",
                              color: "white",
                              cursor: "pointer",
                            }}
                            onClick={handleIncrement}
                          >
                            <HiOutlinePlusSm size={18} id="buyPrice" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                        Sell Price
                      </h4>
                      <div className="ModalContent__set" style={{ border: 0 }}>
                        <input
                          type="number"
                          min="0"
                          name="sellPrice"
                          value={order.sellPrice}
                          onChange={handleChange}
                          style={{ width: "50%" }}
                        />
                        <div className="ModalContent__icons">
                          <button
                            style={{
                              background: "#e8ecf0",
                              cursor: "pointer",
                              visibility:
                                order.sellPrice <= 1 ? "hidden" : "visible",
                            }}
                            onClick={handleDecrement}
                          >
                            <HiOutlineMinusSm size={18} id="sellPrice" />
                          </button>
                          <button
                            style={{
                              background: "#E93848",
                              color: "white",
                              cursor: "pointer",
                              visibility:
                                order.sellPrice === "" ? "hidden" : "visible",
                            }}
                            onClick={handleIncrement}
                          >
                            <HiOutlinePlusSm size={18} id="sellPrice" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <h4 style={{ textAlign: "left", margin: "10px 0" }}>
                    Amount|
                    <span style={{ color: "#BABABA" }}>
                      {activeCrypto.symbol}
                    </span>
                  </h4>
                  {orderType === "buy" && (
                    <>
                      <ReactTooltip
                        place="top"
                        effect="float"
                        multiline={true}
                        id="info"
                      />
                      <FcInfo
                        size={26}
                        data-for="info"
                        data-tip="Amount that you are viewing<br />now, can differ slightly after buying,<br/> due to high price fluctuations"
                      />
                    </>
                  )}{" "}
                </div>

                <div className="ModalContent__set">
                  <input
                    name="amount"
                    type="number"
                    min="0"
                    value={order.amount}
                    readOnly={
                      placeOrderType === "market" && orderType === "buy"
                    }
                    onChange={handleChange}
                  />
                  {!(placeOrderType === "market" && orderType === "buy") && (
                    <div className="ModalContent__icons">
                      <button
                        style={{
                          background: "#e8ecf0",
                          cursor: "pointer",
                          visibility: order.amount <= 1 ? "hidden" : "visible",
                        }}
                        onClick={handleDecrement}
                      >
                        <HiOutlineMinusSm size={18} id="amount" />
                      </button>
                      <button
                        style={{
                          background:
                            orderType === "buy"
                              ? "rgba(69, 170, 67, 1)"
                              : "#E93848",
                          color: "white",
                          cursor: "pointer",
                          visibility:
                            order.amount === "" ? "hidden" : "visible",
                        }}
                        onClick={handleIncrement}
                      >
                        <HiOutlinePlusSm size={18} id="amount" />
                      </button>
                    </div>
                  )}
                </div>
              </>
            </>

            <p></p>
            <h4 style={{ textAlign: "left", margin: "10px 0" }}>
              Total Amount| <span style={{ color: "#BABABA" }}>CST</span>
            </h4>
            <div className="ModalContent__set">
              <input
                type="number"
                name="CSTAmount"
                min="0"
                value={order.CSTAmount}
                readOnly={placeOrderType === "market" && orderType === "sell"}
                onChange={handleChange}
              />
              {!(placeOrderType === "market" && orderType === "sell") && (
                <div className="ModalContent__icons">
                  <button
                    style={{
                      background: "#e8ecf0",
                      cursor: "pointer",
                      visibility: order.CSTAmount <= 1 ? "hidden" : "visible",
                    }}
                    onClick={handleDecrement}
                  >
                    <HiOutlineMinusSm size={18} id="CSTAmount" />
                  </button>
                  <button
                    style={{
                      background:
                        orderType === "buy"
                          ? "rgba(69, 170, 67, 1)"
                          : "#E93848",
                      color: "white",
                      cursor: "pointer",
                      visibility: order.CSTAmount === "" ? "hidden" : "visible",
                    }}
                    onClick={handleIncrement}
                  >
                    <HiOutlinePlusSm size={18} id="CSTAmount" />
                  </button>
                </div>
              )}
            </div>
          </div>

          {message.status === 1 && <Message desc={message.desc} type="error" />}
          {orderType === "sell" &&
            order.buyPrice &&
            !location?.pathname?.split("/")?.includes("screen") && (
              <div className="ModalContent__wallet">
                <div
                  className="ModalContent__wallet_CST"
                  style={{ justifySelf: "start", gap: "10px" }}
                >
                  <GiTwoCoins size={20} />
                  <p style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                    {activePrice.maxAmount}
                  </p>
                </div>
                <div className="ModalContent__wallet-percent">
                  <div
                    onClick={() => {
                      handleCoinAmount(0.25 * activePrice.maxAmount);
                    }}
                  >
                    25%
                  </div>
                  <div
                    onClick={() => {
                      handleCoinAmount(0.5 * activePrice.maxAmount);
                    }}
                  >
                    50%
                  </div>
                  <div
                    onClick={() => {
                      handleCoinAmount(0.75 * activePrice.maxAmount);
                    }}
                  >
                    75%
                  </div>
                  <div
                    onClick={() => {
                      handleCoinAmount(activePrice.maxAmount);
                    }}
                  >
                    100%
                  </div>
                </div>
              </div>
            )}

          {PCSTAmount !== null &&
          orderType === "buy" &&
          vtButton !== "openOrder" ? (
            <div className="ModalContent__wallet">
              <div
                className="ModalContent__wallet_CST"
                style={{ justifySelf: "start" }}
              >
                <BiWallet size={20} />
                <p style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                  {`${formatPrice(PCSTAmount / exchangeRate)} CST`}
                </p>
              </div>
              <div className="ModalContent__wallet-percent">
                <div
                  onClick={() => {
                    handleWalletAmount((0.25 * PCSTAmount) / exchangeRate);
                  }}
                >
                  25%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount((0.5 * PCSTAmount) / exchangeRate);
                  }}
                >
                  50%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount((0.75 * PCSTAmount) / exchangeRate);
                  }}
                >
                  75%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount(PCSTAmount / exchangeRate);
                  }}
                >
                  100%
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {PCSTAmount !== null &&
          orderType === "buy" &&
          activePrice?.totalInvestedForEdit &&
          vtButton === "openOrder" ? (
            <div className="ModalContent__wallet">
              <div
                className="ModalContent__wallet_CST"
                style={{ justifySelf: "start" }}
              >
                <BiWallet size={20} />
                <p style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
                  {`${formatPrice(
                    (PCSTAmount + activePrice.totalInvestedForEdit) /
                      exchangeRate
                  )} CST`}
                </p>
              </div>
              <div className="ModalContent__wallet-percent">
                <div
                  onClick={() => {
                    handleWalletAmount(
                      (0.25 * (PCSTAmount + activePrice.totalInvestedForEdit)) /
                        exchangeRate
                    );
                  }}
                >
                  25%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount(
                      (0.5 * (PCSTAmount + activePrice.totalInvestedForEdit)) /
                        exchangeRate
                    );
                  }}
                >
                  50%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount(
                      (0.75 * (PCSTAmount + activePrice.totalInvestedForEdit)) /
                        exchangeRate
                    );
                  }}
                >
                  75%
                </div>
                <div
                  onClick={() => {
                    handleWalletAmount(
                      (PCSTAmount + activePrice.totalInvestedForEdit) /
                        exchangeRate
                    );
                  }}
                >
                  100%
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>

        <button
          className="TradathonRoom__join__button"
          style={{
            background:
              orderType === "buy" ? "rgba(69, 170, 67, 1)" : "#E93848",
            borderRadius: "5px",
            width: "100%",
            cursor: message.status ? "not-allowed" : "pointer",
          }}
          onClick={handleBuyClick}
          disabled={message.status}
        >
          {location.pathname !== "/tradathon/screen"
            ? orderType.toUpperCase()
            : "ADD COIN"}
        </button>
      </div>
    </div>
  );
};

export default withRouter(Modal);
